/* eslint-disable no-lone-blocks */
import axios from 'axios';
import {
  apiPostHeader,
  apiPostHeaderFn,
  currentCompanyId,
  multipartPartFormDataHeaderFn,
  simpleHeader,
  simpleHeaderFn,
  tokenGetter,
} from '../utils/axios';
import { baseURL, baseURLStaging, baseURLSubmittal, baseURLWage } from '../config-global';
import { handleErrorMessages } from 'src/components/risk-management/risk-register/feching';
import { enqueueSnackbar } from 'notistack';
export const postRequest = async (endPoint, data, isMultiPart) => {
  {
    try {
      const response = await axios.post(`${baseURL}${endPoint}`, data, {
        headers: isMultiPart ? multipartPartFormDataHeaderFn() : apiPostHeaderFn(),
      });
      return response.data;
    } catch (error) {
      return error.response?.data;
    }
  }
};
export const postRequestStart = async (url, data) => {
  {
    try {
      const response = await axios.post(`${baseURLWage}${url}`, data, {
      });
      return response;
    } catch (error) {
      return error.response;
    }
  }
};
export const postRequesttax = async (endPoint, data) => {
  {
    try {
      const response = await axios.post(`${"https://tax.ezelogs.com/generate_tax_info"}`, data, {
        headers: apiPostHeader,
      });
      return response.data;
    } catch (error) {
      return error.response?.data;
    }
  }
};
export const postRequestProject = async (endPoint, data, isMultiPart, currentItem) => {
  {
    try {
      const response = await axios.post(`${baseURL}${endPoint}`, data, {
        headers: {
          Authorization: tokenGetter(),
          currentprojectid: currentItem,
          currentCompanyId: currentCompanyId(),
        },
      });
      return response.data;
    } catch (error) {
      return error.response?.data;
    }
  }
};
export const postRequestStaging = async (endPoint, data, isMultiPart) => {
  {
    try {
      const response = await axios.post(`${baseURLStaging}${endPoint}`, data, {
        headers: isMultiPart ? multipartPartFormDataHeaderFn() : apiPostHeaderFn(),
      });
      return response.data || response;
    } catch (error) {
      return error.response?.data;
    }
  }
};




// submittal post request
export const postRequestSubmittal = async (endPoint, data, isMultiPart) => {
  {
    try {
      const response = await axios.post(`${baseURLSubmittal}${endPoint}`, data, {
        headers: isMultiPart ? multipartPartFormDataHeaderFn() : apiPostHeaderFn(),
      });
      return response.data;
    } catch (error) {
      console.log(error);
      throw error.response?.data?.error || error.response?.data || 'An unexpected error occurred.';
    }
  }
};
export const postRequestDummy = async (endPoint, data, isMultiPart, currentItem) => {
  {
    try {
      const response = await axios.post(`${baseURL}${endPoint}`, data, {
        headers: {
          ...simpleHeaderFn(),
          //currentprojectid: currentItem
        },
      });
      return response.data;
    } catch (error) {
      return error.response?.data;
    }
  }
};

export const getRequest = async (endPoint, isArray = true) => {
  {
    try {
      const response = await axios.get(`${baseURL}${endPoint}`, {
        headers: simpleHeaderFn(),
      });
      return response?.data?.payload || null;
    } catch (error) {
      return isArray ? [] : {};
    }
  }
};

export const getRequestStart = async (endPoint) => {
  {
    try {
      const response = await axios.get(`${baseURLWage}${endPoint}`, {
        headers: simpleHeader,
      });
      return response || null;
    } catch (error) {
      return [];
    }
  }
};

export const getRequestPorject = async (endPoint, isArray = true, currentItem) => {
  {
    try {
      const response = await axios.get(`${baseURL}${endPoint}`, {
        headers: {
          Authorization: tokenGetter(),
          currentprojectid: currentItem,
          currentCompanyId: currentCompanyId(),
        },
      });
      return response?.data?.payload || null;
    } catch (error) {
      return isArray ? [] : {};
    }
  }
};
export const getRequestStaging = async (endPoint, isArray = true) => {
  {
    try {
      const response = await axios.get(`${baseURLStaging}${endPoint}`, {
        headers: simpleHeaderFn(),
      });
      return response?.data?.payload || null;
    } catch (error) {
      return isArray ? [] : {};
    }
  }
};
// submittal get request
export const getRequestSubmittal = async (endPoint) => {
  {
    try {
      console.log(simpleHeaderFn());
      const response = await axios.get(`${baseURL}${endPoint}`, {
        headers: simpleHeaderFn(),
      });
      return response?.data?.payload || null;
    } catch (error) {
      throw error?.response?.data?.message || 'An unexpected error occurred.';
    }
  }
};
export const getRequestV2 = async (endPoint) => {
  {
    try {
      const response = await axios.get(`${baseURL}${endPoint}`, {
        headers: simpleHeaderFn(),
      });
      return response?.data?.payload || null;
    } catch (error) {
      throw error?.response?.data?.message || 'An unexpected error occurred.';
    }
  }
};
export const getRequestDummy = async (endPoint, id, isArray = true) => {
  {
    try {
      const response = await axios.get(`${baseURLStaging}${endPoint}`, {
        headers: {
          ...simpleHeaderFn(),
          currentProjectId: 1297,
        },
      });
      return response?.data?.payload || null;
    } catch (error) {
      return isArray ? [] : {};
    }
  }
};

export const deleteRequest = async (endPoint, callBack) => {
  {
    try {
      const response = await axios.delete(`${baseURL}${endPoint}`, {
        headers: simpleHeaderFn(),
      });
      if (response?.data) {
        const myMetaData = response?.data?.metadata;
        const message = Array.isArray(response?.data?.payload)
          ? response?.data?.metadata?.message
          : response?.data?.payload || response?.data?.metadata?.message;
        if (myMetaData.success) {
          callBack();
          enqueueSnackbar({
            variant: 'success',
            message,
          });
        } else {
          handleErrorMessages(message);
        }
      }
      return response?.data;
    } catch (error) {
      enqueueSnackbar({
        variant: 'error',
        message: 'Oops, something went wrong',
      });
      return error;
    }
  }
};
export const deleteRequestGantt = async (endPoint, callBack) => {
  {
    try {
      const response = await axios.delete(`${baseURL}${endPoint}`, {
        headers: simpleHeaderFn(),
      });
      return response?.data;
    } catch (error) {
      return error.response?.data;
    }
  }
};
